export default __webpack_public_path__ + "static/media/strawberry_slushie.1f8df385.JPG";